import configData from "../config/config.json";

export async function postUpdatedAccountInfo(username, firstname, lastname, emailaddress, phone, roles, managerId, webuserId, userUpdate = false) {
    console.log('this one', webuserId);
    try{
        const url = configData.CCBHTableauAPIServer + "/UpdateAccountInformation?userUpdate=" + userUpdate;
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json',
                     "WebuserID": webuserId
                    },
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "managerId": managerId,
                    "roles": [
                        roles
                    ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
};

export async function addNewEmployee(firstname, lastname, emailaddress, phone, role, managerId){
    try{
        const url = configData.CCBHTableauAPIServer + "/AddNewUser";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify(
                {
                    "firstName": firstname,
                    "lastName": lastname,
                    "username": "",
                    "phoneNumber": phone,
                    "email": emailaddress,
                    "title": "string",
                    "managerId": managerId,
                    "roles": [
                      role
                    ],
                    "userType": "",
                    "entites": [
                      {
                        "name": "",
                        "id": "",
                        "type": 0,
                        "typeDescription": "",
                        "role": role,
                        "enabled": true 
                      }
                    ],
                    "lastLoginDate": "",
                    "directReportEmployees": [],
                    "userID": ""
                  }
                ),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('Added User: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
}

export async function postUpdateUserFirstTimeLogin(username, firstname, lastname, emailaddress, phone, password){
    try{
        const url = configData.CCBHTableauAPIServer + "/updatefirsttimelogin";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "password": password,
                    "managerId": 'managerId',
                    "roles": [ ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
}

export async function postResetPassword(username){
    try{
        const url = configData.CCBHTableauAPIServer + "/password/reset";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                    "webuserID": username,
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    } 
}